if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      if (this.hasUnselectedVariant()) {
        const errorMessage =
          (window.variantStrings && window.variantStrings.selectOption) || 'Please select an option';

        if (this.closest('.sticky-atc__action')) {
          // When the add-to-cart lives in the sticky bar, show the error on the
          // main product form (next to the variant selector) and scroll up to it,
          // rather than in the sticky bar itself.
          const mainForm = Array.from(document.querySelectorAll('product-form')).find(
            (form) => !form.closest('.sticky-atc__action')
          );
          if (mainForm) mainForm.handleErrorMessage(errorMessage);

          const variantSelects = document.querySelector('variant-selects');
          if (variantSelects) {
            variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          this.handleErrorMessage(errorMessage);
        }
        return;
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          // trigger reload minicart
          document.querySelector('#cart-icon-bubble').dispatchEvent(new CustomEvent("refresh", { "detail": "Example of an event" }));
          this.cartNotification.renderContents(response);
          // show mini cart
          document.querySelector('#cart-icon-bubble').click();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');

        });
    }

    hasUnselectedVariant() {
      const selects = document.querySelectorAll('variant-selects select.select__select');
      return Array.from(selects).some((select) => select.value === 'N/A');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}